import React, { useEffect, useState } from 'react';
import { activate } from '../../services/authService';
import { useNavigate, useSearchParams } from 'react-router-dom';
import '../../css/Register.css';
import Logo from "../../assets/img/logo.png";

const Register = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [message, setMessage] = useState('');
    const [token, setToken] = useState('');
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();

    useEffect(() => {
        setToken(searchParams.get('token'));
    }, [searchParams]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            if (password === confirmPassword) {
                await activate(token, password, confirmPassword);
                setMessage('Registration successful!');
                navigate('/login');
            } else {
                setMessage('Error: Passwords do not match.');
            }
        } catch (error) {
            setMessage('Error: Could not register.');
        }
    };

    return (
        <div className="register-container">
            <div className="register-card">
                <div className="logo-and-title">
                    <img width={30} height={30} src={Logo} alt="Logo"/>
                    <h2 className="login-title">Resource Provider</h2>
                </div>
                <form onSubmit={handleSubmit} className="register-form">
                    <input
                        type="password"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="register-input"
                        required
                    />
                    <input
                        type="password"
                        placeholder="Confirm password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        className="register-input"
                        required
                    />
                    <button type="submit" className="register-button">Register</button>
                </form>
                {message && <p className="register-message">{message}</p>}
            </div>
        </div>
    );
};

export default Register;
